import { createContext, useContext } from 'react';
/** @type {import('react').Context<{ menu?: import('reakit').MenuStateReturn }>} */

export var DropdownContext = /*#__PURE__*/createContext({});
export var useDropdownContext = function () {
  return useContext(DropdownContext);
};